// @flow
import * as React from 'react';

import { Accordion, Text, View } from 'reshaped';

import { useTranslator } from '@gandi/translate';

import { AddDiscount } from './Total/AddDiscount';
import { DiscountRows } from './Total/DiscountRows';

type Props = {
  hasDiscounts: boolean,
};

export function DiscountBlock({
  hasDiscounts,
}: Props): React.MixedElement | null {
  const { __ } = useTranslator();

  const [active, setActive] = React.useState(false);
  const inputRef = React.useRef<HTMLInputElement | null>(null);

  React.useEffect(() => {
    if (active) {
      requestAnimationFrame(() => {
        inputRef.current?.focus();
      });
    }
  }, [active]);

  return (
    <View padding={4} borderRadius="large" borderColor="neutral">
      {/** $FlowFixMe[incompatible-type] */}
      <Accordion
        gap={4}
        iconSize={4}
        defaultActive={hasDiscounts}
        active={active}
        onToggle={setActive}
      >
        <Accordion.Trigger>
          <Text variant="body-2" weight="medium">
            {__('Promo code')}
          </Text>
        </Accordion.Trigger>
        <Accordion.Content>
          <View gap={4}>
            {/* $FlowFixMe[incompatible-type] */}
            <AddDiscount ref={inputRef} />
            {hasDiscounts && <DiscountRows />}
          </View>
        </Accordion.Content>
      </Accordion>
    </View>
  );
}
